import { render, staticRenderFns } from "./StatisticsMarketingLead.vue?vue&type=template&id=0b382efe&scoped=true&"
import script from "./StatisticsMarketingLead.vue?vue&type=script&lang=js&"
export * from "./StatisticsMarketingLead.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMarketingLead.vue?vue&type=style&index=0&id=0b382efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b382efe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VAutocomplete,VCard,VCardText,VCol,VIcon,VRow,VSwitch})
